import { watchEffect as r, toValue as a } from "vue";
import { track as n } from "@ds/tracking/tracking";
import { isDev as s } from "../utils/isDev.js";
const l = (o) => {
  const t = s();
  r(() => {
    for (const [e, i] of Object.entries(o))
      a(i) && t && n({
        action: "props-validation-warning",
        context: {
          message: e
        }
      });
  });
};
export {
  l as usePropsValidation
};
